<svelte:options runes={true} />

<script lang="ts">import { defaults } from "./data/selfAssessmentDefaultOptions";
import { sendDYEvents } from "./utils/dy";
import { getCookie } from "../util/cookie";
import FriendlyCaptcha from "../components/FriendlyCaptcha.svelte";
import { onMount, untrack } from "svelte";
import { replaceHiddenInputValues } from "../../src/modules/replaceHiddenInputValues";
onMount(() => {
    replaceHiddenInputValues();
});
let { qnas = [], onSuccess = (_event) => { }, options = defaults, } = $props();
let phoneNumber = $state("");
let form = $state(null);
let disabled = $state(false);
let solution = $state("");
let values = $state(untrack(() => ({
    [options.phoneNumberFieldName]: "",
})));
let validation = $state(untrack(() => ({
    [options.phoneNumberFieldName]: true,
})));
let preValidationValues = $state(untrack(() => ({
    [options.phoneNumberFieldName]: "",
})));
function getUtmTagsFromUrlOrCookie() {
    let utmParams = decodeURIComponent(window.location.search)
        .substr(1)
        .split("&")
        .filter((p) => p.indexOf("utm_") > -1);
    if (utmParams.length > 0) {
        return utmParams.map((param) => param.split("="));
    }
    const utmCookie = getCookie("sec_utm");
    if (utmCookie.length > 0) {
        return utmCookie
            .split("&")
            .map((param) => param.split("="));
    }
    return [];
}
async function postForm(token) {
    if (options.skipPost)
        return Promise.resolve({ success: true, message: "From skipPost" });
    const formData = new FormData(form || undefined);
    // Sanitize the phone number by removing spaces
    const sanitizedPhoneNumber = phoneNumber.replace(/\s+/g, "");
    formData.set("ALL_Phone_Number_Smartphone", sanitizedPhoneNumber); // Use the field name here
    formData.set("token", token);
    formData.set("contentReference", options.id || "");
    formData.set("sent_from_form", "self-assessment");
    formData.set("reasonofContact", options.reasonOfContact);
    formData.set("marketo_campaign", options.marketoCampaign);
    const utmParams = getUtmTagsFromUrlOrCookie();
    utmParams.forEach(([key, value]) => {
        formData.set(key, value);
    });
    // this whole exercise because multiple values may share one 'Form Field' in a 'Form Capture'
    const postValues = {};
    pushPostValues(postValues);
    // Update form data with the grouped values
    Object.keys(postValues).forEach((key) => {
        formData.set(key, postValues[key].join("\n"));
    });
    // prepare for x-www-form-urlencoded POST
    const entries = [...formData.entries()].map((e) => encodeURIComponent(e[0]) +
        "=" +
        encodeURIComponent(e[1].toString()));
    const res = await fetch("/api/clickdimensions/send", {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: entries.join("&"),
    });
    return res.json();
}
function pushPostValues(postValues) {
    if (!!window.DY) {
        pushValueToKey(options.geoLocationFieldName, window.DY.geoCity, postValues);
    }
    if (!!window.ga) {
        const clientId = window.ga.getAll()[0].get("clientId");
        if (clientId) {
            pushValueToKey(options.gaCidFieldName, clientId, postValues);
        }
    }
    pushValueToKey(options.sentFromPageFieldName, location.href, postValues);
    if (qnas.length > 0) {
        pushValueToKey(options.questionAnswersFieldName, qnas.join("\n"), postValues);
    }
}
function pushValueToKey(key, value, postValues) {
    let values = postValues[key] || [];
    values.push(value);
    postValues[key] = values;
}
async function handleSubmit(e) {
    if (disabled)
        return false;
    disabled = true;
    validate();
    if (Object.values(validation).some((v) => !v)) {
        disabled = false;
        return false;
    }
    let token = options.siteKey ? solution : "";
    const { success, message } = await postForm(token);
    if (success) {
        onSuccess(e);
        sendDYEvents(options.category);
    }
    else {
        disabled = false;
        console.error({ message });
    }
}
function validate() {
    if (phoneNumber.length < 5) {
        setInvalidField(phoneNumber, options.phoneNumberFieldName, options.invalidPhoneText);
    }
}
function setInvalidField(value, fieldName, errorText) {
    preValidationValues[fieldName] = value;
    values = Object.assign(Object.assign({}, values), { [fieldName]: errorText });
    validation = Object.assign(Object.assign({}, validation), { [fieldName]: false });
}
</script>

<form
	novalidate
	bind:this={form}
	method="POST"
	onsubmit={(e: SubmitEvent) => {
		e.preventDefault();
		handleSubmit(e);
	}}
	class="ungatedSA"
>
	<h2 class="tp_text-4xl tp_mb-6">{options.title}</h2>
	<p class="tp_mb-6">{options.text}</p>
	<div class="formControl">
		<input name="source_campaign" type="hidden" value="SOURCECAMPAIGN" />
		<div class="error">
			<input
				class="header_advice_dialog_input"
				type="text"
				name="ALL_Phone_Number_Smartphone"
				placeholder="Telefonnummer"
				bind:value={phoneNumber}
			/>
		</div>
		<div>
			<button
				disabled={!solution && !!options.siteKey}
				class="header_advice_dialog_button"
				id="header_advice_dialog_send"
				type="submit"
			>
				{options.submitText}
			</button>
		</div>
	</div>
	{#if options.siteKey}
		<FriendlyCaptcha
			bind:solution
			siteKey={options.siteKey}
			language={options.language}
		/>
	{/if}
</form>

<style lang="scss">.tp_text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}

.tp_mb-6 {
  margin-bottom: 1.5rem;
}

.ungatedSA div.formControl {
  display: flex;
  flex-direction: row;
  border-radius: 30px;
  background: #fff;
  height: 56px;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}
.ungatedSA .header_advice_dialog_input {
  border: none;
  width: 100%;
  flex-grow: 1;
  font-size: 15px;
  line-height: 24px;
  margin-left: 24px;
  background: transparent;
  font-family: secpro__regular, Tahoma, Verdana, sans-serif;
  height: 54px;
}
.ungatedSA button {
  border-radius: 27px !important;
  padding: 10px 24px !important;
  box-sizing: border-box !important;
  font-family: inherit;
  cursor: pointer;
  font-size: 15px !important;
  font-weight: bold !important;
  outline: none !important;
  display: inline-flex !important;
  text-decoration: none !important;
  line-height: 24px !important;
  justify-content: center !important;
  border: none;
  height: auto !important;
  max-width: 100% !important;
  background-image: none !important;
  background-color: #aa1834;
  border: 2px solid #aa1834;
  margin: 4px;
  color: #fff;
}
.ungatedSA button:hover:not([disabled]) {
  background-color: #fd566c;
  border-color: #fd566c;
}
.ungatedSA input:focus {
  outline: none;
}
.ungatedSA div.formControl div.error input {
  color: #aa1834 !important;
  display: block;
}
.ungatedSA div.formControl div.error {
  flex: 1 1;
}</style>
